import { LucideIcon, Sparkles } from 'lucide-react';
import { Card } from './Card';
import { Button } from './Button';

interface ComingSoonProps {
  icon: LucideIcon;
  title: string;
  description: string;
  features?: string[];
}

export function ComingSoon({ icon: Icon, title, description, features }: ComingSoonProps) {
  return (
    <div className="max-w-3xl mx-auto py-12">
      <Card className="text-center">
        <div className="py-12">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br from-blue-100 to-blue-50 rounded-2xl mb-6">
            <Icon size={40} className="text-blue-600" />
          </div>

          <div className="flex items-center justify-center gap-2 mb-4">
            <h2 className="text-2xl font-bold text-gray-900">{title}</h2>
            <div className="inline-flex items-center gap-1 px-2.5 py-1 bg-blue-100 text-blue-700 rounded-full text-xs font-medium">
              <Sparkles size={12} />
              Bientôt disponible
            </div>
          </div>

          <p className="text-gray-600 mb-8 max-w-xl mx-auto">
            {description}
          </p>

          {features && features.length > 0 && (
            <div className="max-w-md mx-auto mb-8">
              <p className="text-sm font-medium text-gray-700 mb-4">Fonctionnalités prévues :</p>
              <ul className="text-left space-y-2">
                {features.map((feature, index) => (
                  <li key={index} className="flex items-start gap-3 text-sm text-gray-600">
                    <span className="inline-block w-1.5 h-1.5 bg-blue-600 rounded-full mt-1.5 flex-shrink-0"></span>
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          )}

          <Button variant="outline" disabled>
            Cette fonctionnalité est en développement
          </Button>
        </div>
      </Card>
    </div>
  );
}
